import { GlobalFilterDetail } from '@/common/entities/filter/GlobalFilterDetail';
import { EntityView } from '@/common/entityFramework/entityView/EntityView';
import { Route } from 'react-router-dom';
import { DirSaleDashboard } from './entities/dirSale/dashboard/DirSaleDashboard';

const aesScRoutes = [
  <Route path="/sc/filter" element={<EntityView detailComponent={GlobalFilterDetail} />} />,
  <Route path="/sc/dir-sale-dashboard" element={<DirSaleDashboard />} />,
];

export default aesScRoutes;
